import React from 'react';
import { NavLink } from 'react-router';
import { Building2, Users, UserCog, Scale, ShieldCheck } from 'lucide-react';

const ApplicationSidebar7: React.FC = () => (
  <aside className="sa-sidebar">
    <nav className="app-sidebar-nav">
      <NavLink
        to="/super-admin/entities"
        className={({ isActive }) => `app-sidebar-item${isActive ? ' active' : ''}`}
        aria-label="Entities"
        data-testid="NAV_sa_sidebar_entities"
      >
        <span className="app-sidebar-icon"><Building2 size={18} /></span>
        <span className="app-sidebar-label">Entities</span>
      </NavLink>
      <NavLink
        to="/super-admin/admins"
        className={({ isActive }) => `app-sidebar-item${isActive ? ' active' : ''}`}
        aria-label="Entity Admins"
        data-testid="NAV_sa_sidebar_admins"
      >
        <span className="app-sidebar-icon"><UserCog size={18} /></span>
        <span className="app-sidebar-label">Entity Admins</span>
      </NavLink>
      <NavLink
        to="/super-admin/users"
        className={({ isActive }) => `app-sidebar-item${isActive ? ' active' : ''}`}
        aria-label="Users"
        data-testid="NAV_sa_sidebar_users"
      >
        <span className="app-sidebar-icon"><Users size={18} /></span>
        <span className="app-sidebar-label">Users</span>
      </NavLink>
      <NavLink
        to="/super-admin/litigation-proceedings"
        className={({ isActive }) => `app-sidebar-item${isActive ? ' active' : ''}`}
        aria-label="Litigation Proceedings"
        data-testid="NAV_sa_sidebar_lit_proceedings"
      >
        <span className="app-sidebar-icon"><Scale size={18} /></span>
        <span className="app-sidebar-label">Lit. Proceedings</span>
      </NavLink>
      <NavLink
        to="/super-admin/rbac"
        className={({ isActive }) => `app-sidebar-item${isActive ? ' active' : ''}`}
        aria-label="RBAC Roles"
        data-testid="NAV_sa_sidebar_rbac"
      >
        <span className="app-sidebar-icon"><ShieldCheck size={18} /></span>
        <span className="app-sidebar-label">RBAC Roles</span>
      </NavLink>
    </nav>
  </aside>
);

export default ApplicationSidebar7;
